import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { openHelp } from '~/store/modules/help/actions';
import { Button } from '~/elements';
import Icon from '~/elements/Icon';
import { TitleContainer, Title, Description, ContainerButton } from '../common';

const ResetPasswordSuccess = ({ issuer, handleClose, email }) => {
  const dispatch = useDispatch();

  const handleNeedHelp = useCallback(() => {
    handleClose();
    dispatch(openHelp());
  }, [handleClose, openHelp]);

  return (
    <>
      <div className="icon">
        <Icon icon={['fal', 'check-circle']} />
      </div>

      <TitleContainer>
        <Title>Verifique seu e-mail</Title>
      </TitleContainer>
      <Description>
        Você irá receber as instruções para criar uma nova senha
        <br /> no e-mail <b>{email}</b> se ele for um e-mail cadastrado na{' '}
        {issuer}.
      </Description>

      <ContainerButton>
        <Button
          variant="contained"
          label="Precisa de ajuda?"
          ariaLabel="Precisa de ajuda?"
          style={{ width: 600 }}
          onClick={() => {
            handleNeedHelp();
          }}
        />
      </ContainerButton>
    </>
  );
};

ResetPasswordSuccess.propTypes = {
  issuer: PropTypes.string,
  handleClose: PropTypes.func,
  email: PropTypes.string,
};

export default ResetPasswordSuccess;
